var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBoNext(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 27,
    height: 27,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 0 27.0132)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6845 9.01447C11.5258 9.01415 11.3719 9.07212 11.2496 9.17833C11.1808 9.23814 11.124 9.31159 11.0823 9.39449C11.0406 9.47738 11.0149 9.56807 11.0067 9.66139C10.9985 9.7547 11.0079 9.84879 11.0344 9.93828C11.061 10.0278 11.1041 10.1109 11.1613 10.1829L15.2011 13.998L11.152 17.8311C11.0956 17.904 11.0534 17.9878 11.028 18.0778C11.0025 18.1678 10.9943 18.2622 11.0038 18.3556C11.0133 18.4489 11.0402 18.5394 11.0832 18.6218C11.1261 18.7042 11.1841 18.7768 11.2539 18.8356C11.3242 18.9005 11.4066 18.9494 11.4958 18.9793C11.585 19.0092 11.6791 19.0195 11.7723 19.0095C11.8654 18.9994 11.9556 18.9693 12.0371 18.921C12.1186 18.8727 12.1898 18.8073 12.246 18.7288L16.8454 14.4504C16.9454 14.3229 17 14.163 17 13.998C17 13.833 16.9454 13.6731 16.8454 13.5456L12.2485 9.27095C12.1804 9.18473 12.0938 9.11658 11.9958 9.07202C11.8978 9.02745 11.7912 9.00774 11.6845 9.01447Z",
    fill: "#666666"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 27,
    height: 27,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 0 27.0132)",
    stroke: "#CCCCCC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoNext);
export default __webpack_public_path__ + "static/media/icon__bo__next.758999dbdbc7ad23e7bb0177ad64ffec.svg";
export { ForwardRef as ReactComponent };